import { MessageId, TargetMessage } from '@angular/localize';
import localeEn from '@angular/common/locales/en';
import localeHi from '@angular/common/locales/hi';
import localeKn from '@angular/common/locales/kn';
import localeTe from '@angular/common/locales/te';
import localeMr from '@angular/common/locales/mr';
import localeBn from '@angular/common/locales/bn';
import en from './locale-i18n/en.json';
import hi from './locale-i18n/hi.json';
import kn from './locale-i18n/kn.json';
import te from './locale-i18n/te.json';
import mr from './locale-i18n/mr.json';
import bn from './locale-i18n/bn.json';
import { SUPPORTED_LOCALES } from './supported_locale';

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

/**
 * Both maps must stay keyed by every SUPPORTED_LOCALES entry — a locale the app routes to but
 * cannot look up here bootstraps with no translations. main.ts empties them after bootstrap.
 */
export const LanguageTranslationMap: Record<SupportedLocale, Record<MessageId, TargetMessage>> = {
  en, hi, kn, te, mr, bn,
};

export const LanguageLocaleData: Record<SupportedLocale, unknown> = {
  en: localeEn, hi: localeHi, kn: localeKn, te: localeTe, mr: localeMr, bn: localeBn,
};
